export default "__VITE_ASSET__e916a8be__"